module.exports = __webpack_public_path__ + "static/media/headshot.3705216c.jpg";